<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="pt-5">
    <strong>{{ resourceName }}</strong>
    <div class="row">
      <div class="col-12">
        <label for="searchBox">Search</label>
        <div class="d-flex align-items-center">
          <input
            id="searchBox"
            v-model="keyword"
            class="form-control"
            style="width: 40%; margin: 0.7rem 0"
            type="text"
          />
          <button class="btn btn-outline-primary ml-2" @click="searchResources">
            OK
          </button>
          <button
              @click="goAdd"
              class="btn btn-outline-success ml-auto"
              v-if="hasEditPermission"
          >
            Add
          </button>
        </div>
      </div>
    </div>
    <b-table
      class="table table-responsive table-bordered mt-5"
      hover
      responsive
      :fields="fields"
      :items="resourceList"
      :per-page="perPage"
      @sort-changed="sortCompare"
    >
      <template #table-caption v-if="resourceList.length === 0">
        <h5 class="text-center pt-10">There is no resource data</h5>
      </template>
      <template #cell(action)="data">
        <div class="d-flex justify-content-evenly">
          <button
              class="btn btn-outline-primary"
              v-if="hasEditPermission"
              @click="goDetail(data.item.id)"
          >
            Detail
          </button>
        </div>
      </template>
    </b-table>
    <b-pagination
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
      class="my-0"
      aria-controls="my-table"
      @input="changePage"
    ></b-pagination>
  </div>
</template>

<script>
import DefaultListViewData from "@/views/defaultListViewData";
import ServiceResourceService from "services/api/serviceResource.service";
import fields from "./listResourceFields.json";

export default {
  props: {
    resourceName: {
      type: String,
      required: true,
    },
    resourceType: {
      type: String,
      required: true,
    },
    storeCode: {
      type: String,
      required: true,
    },
    hasEditPermission: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ...DefaultListViewData,
      keyword: null,
      isSubmit: false,
      message: null,
      resourceList: [],
      fields,
    };
  },

  computed: {
    kwKey() {
      return this.resourceType === "ROOM" ? "kwRoom" : "kwStaff";
    },
  },

  async mounted() {
    const raw = this.$route.query[this.kwKey];
    this.keyword = typeof raw === 'string' && raw.trim() ? raw.trim() : null;

    this.isLoading = true;
    await this.getResources();
  },

  methods: {
    async getResources() {
      this.isLoading = true;
      const params = this.getParams();
      if (this.resourceType === "ROOM") {
        await ServiceResourceService.getListRoom(this.storeCode, params)
          .then((res) => {
            this.getRooms(res);
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else if (this.resourceType === "STAFF") {
        await ServiceResourceService.getListStaff(this.storeCode, params)
          .then((res) => {
            this.getStaffs(res);
          })
          .catch((err) => {
            this.requestFailure(err);
          });
      } else {
        await this.$router.push({ name: "StoreMaster" });
      }
    },
    getRooms(result) {
      this.isLoading = false;
      const data = result.data;
      this.totalItems = data.totalItems;
      this.resourceList = data.rooms.map((r) => {
        return {
          ...r,
          status: this.leadWithUpperCase(r.status),
        };
      });
    },
    getStaffs(result) {
      this.isLoading = false;
      const data = result.data;
      this.totalItems = data.totalItems;
      this.resourceList = data.staffs.map((r) => {
        return {
          ...r,
          status: this.leadWithUpperCase(r.status),
        };
      });
    },
    getParams() {
      return {
        keyword: this.keyword,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: this.sort.key || "",
        sortType: this.sort.type || "",
      };
    },
    leadWithUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getResources();
    },
    changePage() {
      this.getResources();
    },
    searchResources() {
      this.isLoading = true;
      this.currentPage = 1;
      this.updateUrlKeyword();
      this.getResources();
    },

    clearSearch() {
      this.keyword = null;
      this.currentPage = 1;
      this.sort = {key: "", type: ""};
      this.sortDesc = false;
      this.updateUrlKeyword();
      this.getResources();
    },

    goDetail(itemId) {
      const base = this.cleanedQuery();
      const next = {
        ...(base.tab === null ? {} : { tab: base.tab }),
        resourceType: this.resourceType,
        id: itemId,
      };
      const kw = (this.keyword || '').trim();
      if (kw) next[this.kwKey] = kw;
      this.$router.push({ name: 'DetailResourceMaster', query: next });
    },

    goAdd() {
      this.$router.push({
        name: "DetailResourceMaster",
        query: { resourceType: this.resourceType },
      });
    },

    requestFailure(err) {
      console.log("Error: ", err);
      this.isLoading = false;
    },

    cleanedQuery(base = this.$route.query) {
      const q = { ...base };
      delete q.kwRoom;
      delete q.kwStaff;
      return q;
    },

    updateUrlKeyword() {
      const q = this.cleanedQuery();
      const next = { ...(q.tab === null ? {} : { tab: q.tab }) };
      const kw = (this.keyword || '').trim();
      if (kw) next[this.kwKey] = kw;

      this.$router.replace({ query: next });
    },
  },
};
</script>
